<script lang="ts">
	import type { EditorContent } from "$lib/types/editor-content";
	import type { OutputBlockData } from "@editorjs/editorjs";
    import EditorJsHTML from "editorjs-html";

    let { value } = $props<{ value: OutputBlockData<string, any>[] | EditorContent }>();

    const customParsers = {
        paragraph: (block: any) => {
            return `<p class="paragraph">${block.data.text}</p>`;
        },
        header: (block: any) => {
            return `<h${block.data.level} class="heading heading--${block.data.level}">${block.data.text}</h${block.data.level}>`;
        },
        list: (block: any) => {
            const tag = block.data.style === 'ordered' ? 'ol' : 'ul';
            const items = block.data.items
            .map((item: string) => `<li class="list__item">${item}</li>`)
            .join('');
            return `<${tag} class="list">${items}</${tag}>`;
        },
        image: (block: any) => {
            return `<img class="content-image" src="${block.data.file.url}" alt="${block.data.caption}">`;
        },
        centeredParagraph: (block: any) => {
            return `<p class="paragraph text-center">${block.data.text}</p>`;
        }
    };
    const edjsParser = EditorJsHTML(customParsers);
    const html = edjsParser.parse(value);
</script>

<div>
    {@html html}
</div>